export const getPartnerConfig = (token: string) => ["PARTNER_BY_ML", token];
